import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './QualityLabel.styles'
import { quatroSeals } from 'assets/img'
import { Tooltip } from 'components/atoms'

/**
 * @returns {*}
 * @constructor
 */
const QualityLabel = ({ itemList }) => {
  const getImageByType = (type, year, title) => {
    const src = quatroSeals[year][type]

    return <img className={ 'quatro-image' } src={ src } alt={ title } />
  }

  return (
    <Styled.QualityLabelComponent>
      {itemList &&
        itemList.map((item, index) => (
          <div key={ index } className={ 'item-container' }>
            {Object.prototype.hasOwnProperty.call(item, 'type') &&
              Object.prototype.hasOwnProperty.call(item, 'year') &&
              getImageByType(item.type, item.year, item.title)}
            <div className={ 'quality-description' }>
              {item?.title && (
                <p>
                  <b>{item.title}</b>
                  {item?.tip && (
                    <Tooltip
                      infoIconId={ item.title }
                      dialogTitle={ item.title }
                      tooltipId={ item.title }
                      className={ 'quality-tooltip' }>
                      {item.tip}
                    </Tooltip>
                  )}
                </p>
              )}
              {item?.text && <p>{item.text}</p>}
            </div>
          </div>
        ))}
    </Styled.QualityLabelComponent>
  )
}

QualityLabel.propTypes = {
  itemList: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['quatro-gold', 'quatro-silver', 'quatro-green'])
        .isRequired,
      title: PropTypes.string,
      text: PropTypes.string,
      tip: PropTypes.string,
      year: PropTypes.string.isRequired,
    })
  ),
}

export default QualityLabel
